import React from 'react';
import { Screen } from '~/screens/users/[id]';

export const UserDetail: React.FC = () => <Screen />;
